import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "mb-4"
}
const _hoisted_2 = { class: "underline-text" }

import TimepickerSmall from "@/components/inputs/TimepickerSmall.vue";
import {ref, watch} from "vue";
import {Task} from "@/types/Order";
import StateSelect from "@/components/inputs/StateSelect.vue";
import PrioritySelect from "@/components/inputs/PrioritySelect.vue";
import GroupSelect from "@/components/inputs/GroupSelect.vue";
import LotoAreaSelect from "@/components/inputs/LotoAreaSelect.vue";
import {VForm} from "vuetify/components";
import {openDriveInformationDialog, useGlobalSetting} from "@/lib/utils";
import {checkMotorId} from "@/types/Drive";

interface AufgabenTab {
  icon: string;
  text: string;
  value: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TaskInformationDialog',
  props: /*@__PURE__*/_mergeModels({
  readonly: {
    type: Boolean,
    default: false,
  }
}, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {

const isMotorRef = ref<boolean>(false);

const formRefs = ref<InstanceType<typeof VForm>[]>([]);

const aufgabe = _useModel<Task>(__props, "modelValue");

isMotor(aufgabe.value?.asset_id);

const props = __props;

//const emit = defineEmits(["updateChangeList", "updateDeletedList"])

watch(aufgabe, (p) => {
  useGlobalSetting().hasChanged = true;
  //emit('updateChangeList', aufgabe);
});

function validateForm() {
  if (!formRefs.value.length) return Promise.resolve(false)
  Promise.all(formRefs.value.map(f => f.validate())).then((result) => {
    return result.every(r => r.valid);
  })
}

function isMotor(assetId: string | null | undefined) {
  if (!assetId) return;
  let id = String(assetId);
  if (id.toLowerCase().startsWith("spm"))
    id = id.substring(3);
  checkMotorId(id).then(data => {
    isMotorRef.value = data;
  });
}

function openMotorInformation(assetId: string | null | undefined) {
  if (!assetId) return;
  let id = String(assetId);
  let _id = id;
  if (id.toLowerCase().startsWith("spm"))
    _id = id.substring(3);
  openDriveInformationDialog(_id, false)
}

__expose({validateForm});

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_unref(VForm), { ref: "formRef" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, {
        class: "pa-0",
        fluid: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: aufgabe.value.id,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((aufgabe.value.id) = $event)),
                    class: _normalizeClass(__props.readonly ? 'custom-readonly' : ''),
                    readonly: __props.readonly,
                    label: "ID",
                    title: "ID",
                    variant: _unref(useGlobalSetting)().globalTextVariant
                  }, null, 8, ["modelValue", "class", "readonly", "variant"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "10"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: aufgabe.value.title,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((aufgabe.value.title) = $event)),
                    class: _normalizeClass(__props.readonly ? 'custom-readonly' : ''),
                    readonly: __props.readonly,
                    label: "Titel",
                    required: "",
                    title: "Titel",
                    variant: _unref(useGlobalSetting)().globalTextVariant
                  }, null, 8, ["modelValue", "class", "readonly", "variant"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_textarea, {
                    modelValue: aufgabe.value.description,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((aufgabe.value.description) = $event)),
                    class: _normalizeClass(__props.readonly ? 'custom-readonly' : ''),
                    readonly: __props.readonly,
                    label: "Beschreibung",
                    "no-resize": "",
                    required: "",
                    title: "Beschreibung",
                    variant: _unref(useGlobalSetting)().globalTextVariant
                  }, null, 8, ["modelValue", "class", "readonly", "variant"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                class: "d-flex flex-column",
                cols: "12",
                sm: "4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: aufgabe.value.asset_id,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((aufgabe.value.asset_id) = $event)),
                    class: _normalizeClass(__props.readonly ? 'custom-readonly' : ''),
                    readonly: __props.readonly,
                    label: "AKZ",
                    required: "",
                    title: "AKZ",
                    variant: _unref(useGlobalSetting)().globalTextVariant
                  }, null, 8, ["modelValue", "class", "readonly", "variant"]),
                  _createVNode(GroupSelect, {
                    modelValue: aufgabe.value.work_group,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((aufgabe.value.work_group) = $event)),
                    class: _normalizeClass(__props.readonly ? 'custom-readonly' : ''),
                    readonly: __props.readonly,
                    required: ""
                  }, null, 8, ["modelValue", "class", "readonly"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                class: "d-flex flex-column",
                cols: "12",
                sm: "4"
              }, {
                default: _withCtx(() => [
                  _createVNode(StateSelect, {
                    modelValue: aufgabe.value.state,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((aufgabe.value.state) = $event)),
                    class: _normalizeClass(__props.readonly ? 'custom-readonly' : ''),
                    readonly: __props.readonly,
                    required: "",
                    variant: _unref(useGlobalSetting)().globalTextVariant
                  }, null, 8, ["modelValue", "class", "readonly", "variant"]),
                  _createVNode(PrioritySelect, {
                    modelValue: aufgabe.value.priority,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((aufgabe.value.priority) = $event)),
                    class: _normalizeClass(__props.readonly ? 'custom-readonly' : ''),
                    readonly: __props.readonly,
                    required: "",
                    variant: _unref(useGlobalSetting)().globalTextVariant
                  }, null, 8, ["modelValue", "class", "readonly", "variant"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: aufgabe.value.assignee,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((aufgabe.value.assignee) = $event)),
                    class: _normalizeClass(__props.readonly ? 'custom-readonly' : ''),
                    readonly: __props.readonly,
                    label: "AGL",
                    required: "",
                    title: "AGL",
                    variant: _unref(useGlobalSetting)().globalTextVariant
                  }, null, 8, ["modelValue", "class", "readonly", "variant"]),
                  _createVNode(TimepickerSmall, {
                    modelValue: aufgabe.value.scheduled_duration,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((aufgabe.value.scheduled_duration) = $event)),
                    class: _normalizeClass(__props.readonly ? 'custom-readonly' : ''),
                    readonly: __props.readonly,
                    label: "Solldauer",
                    required: ""
                  }, null, 8, ["modelValue", "class", "readonly"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (aufgabe.value?.is_lockout)
            ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(LotoAreaSelect, {
                        modelValue: aufgabe.value.loto_area_id,
                        "onUpdate:modelValue": [
                          _cache[9] || (_cache[9] = ($event: any) => ((aufgabe.value.loto_area_id) = $event)),
                          _cache[10] || (_cache[10] = ($event: any) => (_unref(useGlobalSetting)().hasChanged = true))
                        ],
                        label: "Freischaltbereich",
                        "prepend-icon": "mdi-map",
                        "hide-details": false,
                        density: "default"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_col, {
                    cols: "12",
                    sm: "6",
                    class: "d-flex align-center"
                  }, {
                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                      _createElementVNode("span", { class: "text-caption text-medium-emphasis" }, " Bestimmt, auf welchem Bereich des Freischaltplans diese Aufgabe erscheint. ", -1)
                    ])),
                    _: 1,
                    __: [14]
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: aufgabe.value.scheduled_start,
                    "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((aufgabe.value.scheduled_start) = $event)),
                    class: _normalizeClass(__props.readonly ? 'custom-readonly' : ''),
                    readonly: __props.readonly,
                    label: "Sollstart",
                    required: "",
                    title: "Sollstart",
                    type: "datetime-local",
                    variant: _unref(useGlobalSetting)().globalTextVariant
                  }, null, 8, ["modelValue", "class", "readonly", "variant"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                sm: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: aufgabe.value.scheduled_end,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((aufgabe.value.scheduled_end) = $event)),
                    class: _normalizeClass(__props.readonly ? 'custom-readonly' : ''),
                    readonly: __props.readonly,
                    label: "Sollende",
                    required: "",
                    title: "Sollende",
                    type: "datetime-local",
                    variant: _unref(useGlobalSetting)().globalTextVariant
                  }, null, 8, ["modelValue", "class", "readonly", "variant"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (isMotorRef.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("a", {
                  href: "#",
                  onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (openMotorInformation(aufgabe.value?.asset_id)), ["prevent"])),
                  target: "_blank",
                  rel: "noopener",
                  class: "link-with-icon color_pro-rot"
                }, [
                  _createVNode(_component_v_icon, {
                    start: "",
                    class: "no-underline"
                  }, {
                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                      _createTextVNode("mdi-open-in-app")
                    ])),
                    _: 1,
                    __: [15]
                  }),
                  _createElementVNode("span", _hoisted_2, "Zusätzliche Informationen für " + _toDisplayString(aufgabe.value?.asset_id), 1)
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})